import * as React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Cell, CellType, RowContent } from "@tenforce/toolbox-table-react"

import { connect } from "react-redux"
import { DispatchProps, mapDispatchToProps } from "../actions"
import { formatString } from "../../../util/Strings"
import { GlobalState } from "../../../store"
import { Labels } from "../../../util/Translations"
import { IWorkspaceListPage } from "../index"

type StateProps = IWorkspaceListPage

type Props = StateProps & DispatchProps

export class LoadMore extends React.Component<Props> {
    render(): JSX.Element {
        const { LoadNMore } = Labels
        const {
            pagination: { pageSize, count },
            workspaces,
        } = this.props

        const workspacesLeft = count - workspaces.length
        const nextPageSize =
            workspacesLeft < pageSize ? workspacesLeft : pageSize
        const loadMoreLabel = formatString(LoadNMore, nextPageSize)

        return (
            <RowContent key="loadmore">
                <Cell type={CellType.action}>
                    <Action
                        actionType={ActionType.block}
                        extraClasses="tw-px-6"
                        onClick={this.loadMore}
                        data-ft-component="loadMore"
                    >
                        {loadMoreLabel}
                    </Action>
                </Cell>
            </RowContent>
        )
    }

    loadMore = (): void => {
        const { loadMoreWorkspaces } = this.props
        loadMoreWorkspaces()
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.workspaceListPage,
})

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore)
